const newTechnologyData = {
  hero: 'https://res.cloudinary.com/benchmarkminerals/image/upload/v1732133794/assets/data-reports/price-assessments/benchmarkminerals_Charts_and_graphs_about_Lithium_photorealisti_7eca0b4b-7d38-424c-bab2-849549dd2440_p8whk4.png',
  forecastBrochureFile: {
    EnvKey: 'forecastBrochureSolidStateLithiumMetalBatteriesFilePdfID',
    file_name: 'Solid-state and Lithium Metal Batteries Forecast Brochure.pdf',
    category: 'public-documents',
  },
}
export default newTechnologyData
